module.exports = __webpack_public_path__ + "static/media/elon_musk.cff87dbe.png";